/**
 * 打印机模块 - 常量定义
 * 
 * @module types/printer/constants
 * @description 打印机相关常量和映射表
 * @backend-file backend/app/Modules/Printer/Models/Printer.php
 * @author YSFL Team
 * @date 2025-11-03
 */

import { PrinterType, PrinterStatus } from './enums'

/**
 * 打印机类型映射
 */
export const PRINTER_TYPE_LABELS: Record<PrinterType, string> = {
  [PrinterType.BLUETOOTH]: '蓝牙',
  [PrinterType.WIFI]: 'WiFi',
}

/**
 * 打印机状态映射
 */
export const PRINTER_STATUS_LABELS: Record<PrinterStatus, string> = {
  [PrinterStatus.ONLINE]: '在线',
  [PrinterStatus.OFFLINE]: '离线',
  [PrinterStatus.ERROR]: '故障',
  [PrinterStatus.DISABLED]: '禁用',
}

/**
 * 打印机类型选项
 */
export const PRINTER_TYPE_OPTIONS = [
  { label: '蓝牙', value: PrinterType.BLUETOOTH },
  { label: 'WiFi', value: PrinterType.WIFI },
]

/**
 * 打印机状态选项
 */
export const PRINTER_STATUS_OPTIONS = [
  { label: '在线', value: PrinterStatus.ONLINE },
  { label: '离线', value: PrinterStatus.OFFLINE },
  { label: '故障', value: PrinterStatus.ERROR },
  { label: '禁用', value: PrinterStatus.DISABLED },
]

